<template>
  <dl :class="['spec-group', 'error-block', isError ? 'is-error' : '']">
    <dt>{{ spec.text }}</dt>
    <dd
      :class="[
        'spec-item',
        isSelected(color) ? 'is-active' : '',
        color.enabled ? '' : 'is-disabled'
      ]"
      v-for="(color, i) in spec.values"
      :key="i">
      <label @click="onColorClick(color)">
        <i
          :class="[
            'icon-checkbox',
            isSelected(color) ? 'icon-checkbox--checked' : '',
            !color.enabled || spec.values.length === 1
              ? 'icon-checkbox--disabled'
              : ''
          ]"></i>
        <span
          class="spec-item__img"
          v-if="spec.isSpecImage"
          v-on:mouseover="showBigImg(color, $event)"
          v-on:mouseout="hideBigImg($event)">
          <img
            class="spec-option-image"
            :src="color.specImg"
            :alt="color.text" />
        </span>
        <span class="spec-item__text">{{ color.text }}</span>
        <span
          class="spec-item__price"
          v-if="
            (color.value == 'No' && color.text == 'No') == false &&
            color.text == color.value
          "
          >{{ color.price > 0 ? `${formatCurrency(color.price)} each.` : 'Free' }}</span
        >
      </label>
    </dd>
    <dd class="error-label" v-show="isError">
      Please, select {{ spec.name }}.
    </dd>
  </dl>
</template>

<script lang="ts">
import { type SpecGroup, type SpecItem } from '../../types'
import { computed, defineComponent, inject, type PropType } from 'vue'
import { SHOW_BIG_IMAGE_KEY } from '../../token'
import { formatCurrency } from '@anypromo/shared/utils/helper'

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<SpecItem>,
      default: () => undefined
    },
    spec: {
      type: Object as PropType<SpecGroup>,
      default: {} as unknown
    },
    isClicked: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'update:modelValue': (color?: SpecItem) => true,
    'disabled-color-click': (group: SpecGroup, color: SpecItem) => true
  },
  setup(props, { emit, expose }) {
    const showBigImage = inject(SHOW_BIG_IMAGE_KEY)
    if (!showBigImage) {
      console.warn('build error')
    }
    

    const isSelected = (color: SpecItem) =>
      props.modelValue?.value === color.value

    const isError = computed(() => {
      return (
        props.isClicked &&
        (props.modelValue === null || props.modelValue === undefined)
      )
    })

    const showBigImg = (color: SpecItem, evt: MouseEvent) => {
      if (showBigImage) {
        const specImage = color.specImg.replace('specimage_0030', 'specimage_medium')
        const target = evt.target as HTMLElement
        showBigImage.show(specImage, '', target)
      }
    }
    const hideBigImg = (evt: MouseEvent) => {
      if (showBigImage) {
        showBigImage.hide()
      }
    }

    // useParent(specContextKey)
    const onColorClick = (color: SpecItem) => {
      if (props.spec.values.length === 1) {
        return
      }
      // 如果颜色不可选，那就出发提示
      if (color.enabled === false) {
        emit('disabled-color-click', props.spec, color)
        return
      }
      if (props.modelValue === color) {
        emit('update:modelValue', undefined)
      } else {
        emit('update:modelValue', color)
      }
    }

    // onMounted(() => {
    //   bus.on('spec-validate', () => {
    //     isError.value = !!props.modelValue
    //   })
    // })

    return {
      // selectedValues,
      isSelected,
      isError,
      showBigImg,
      hideBigImg,
      onColorClick,
      formatCurrency
    }
  }
})
</script>
<style lang="less">
.spec-group {
  padding: 0;
  margin-bottom: 2px;
  dt {
    display: block;
    margin-bottom: 6px;
    font-size: 14px;
  }
}
.spec-item {
  label {
    font-weight: 500;
    padding: 5px 20px;
    font-size: 13px;
    cursor: pointer;
    max-width: 100%;
    margin-bottom: 5px;
    display: inline-flex;
    align-items: center;
    &:hover {
      background-color: #fff4de;
    }
  }
  span {
    display: inline-block;
  }
  &__img {
    margin-left: 7px;
    width: 30px;
    text-align: center;
    vertical-align: middle;
    img {
      vertical-align: middle;
    }
  }
  &__text {
    flex: 1;
    margin-left: 15px;
    vertical-align: middle;
    text-align: left;
  }
  &__price {
    font-style: normal;
    display: inline-block;
    text-align: left;
    min-width: 60px;
    &::before {
      content: '-';
      padding: 0 5px;
    }
  }

  &.is-disabled {
    label {
      cursor: not-allowed;
    }
  }
  &.is-disabled {
    color: #ddd;
  }

  &.is-disabled &__img {
    opacity: 0.3;
  }
}
</style>
